import { render, staticRenderFns } from "./ArtisanAppointmentConfirmation.vue?vue&type=template&id=4ce032f5&scoped=true"
import script from "./ArtisanAppointmentConfirmation.vue?vue&type=script&lang=ts"
export * from "./ArtisanAppointmentConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce032f5",
  null
  
)

export default component.exports